<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="first-name">Имя</label>
    <input
      type="text"
      class="form-control"
      id="first-name"
      placeholder="Введите имя"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'client-first-name-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ClientFirstName.vue?b6e34516